import {
  Alert,
  CardActions,
  CardHeader,
  Divider,
  Grid,
  LinearProgress,
  Paper,
  Stack,
} from "@mui/material";
import { useEffect, useState } from "react";
import AppButton from "../../shares/AppButton";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import { DeleteOutline, EditOutlined, InfoOutlined } from "@material-ui/icons";
import { CalendarMonthOutlined } from "@mui/icons-material";
import TopicOutlinedIcon from "@mui/icons-material/TopicOutlined";
import WorkspacePremiumOutlinedIcon from "@mui/icons-material/WorkspacePremiumOutlined";
import FormationForm from "./forms/FormationForm";
import { useQuery } from "../../../../hooks/useQuery";
import useConfirm from "../../../../hooks/useConfirm";
import useToast from "../../../../hooks/useToast";
import { TYPE_NOTIFICATION } from "../../shares/NotificationBull";
import { CVFormationService } from "../../../../service/CVFormationService";

const Formations = () => {
  const [formations, setFormations] = useState([]);
  const [formDialogOpen, setFormDialogOpen] = useState(false);
  const [selectedFormation, setSelectedFormation] = useState({});
  const { DialogComponent, openConfirmDialog } = useConfirm();
  const [formLoading, setFormLoading] = useState(false);
  const { Toast, showToast } = useToast();

  const query = useQuery();
  const id_ext_user = query.get("ref");
  const handleCloseformationForn = () => {
    setFormDialogOpen(false);
    handleFetchFormations();
  };

  const confirmDelete = (data) => {
    CVFormationService.delete(data).then((res) => {
      if (res && res.success) {
        showToast(TYPE_NOTIFICATION.SUCCESS, res.message);
        handleFetchFormations();
      } else {
        showToast(TYPE_NOTIFICATION.ERROR, res.message);
      }
    });
  };

  const handleDeleteFormation = (formation) => {
    openConfirmDialog(
      "Confirmation",
      "Voullez vous supprimer cette ligne?",
      () => confirmDelete(formation),
    );
  };

  const handleEditFormation = (formation) => {
    setSelectedFormation(formation);
    setFormDialogOpen(true);
  };

  const handleOpenformationFormDialog = (formation) => {
    setFormDialogOpen(true);
    setSelectedFormation({});
  };

  const handleFetchFormations = () => {
    setFormLoading(true);
    CVFormationService.liste({
      id_ext_user: id_ext_user,
    })
      .then((res) => {
        if (res && res.data) {
          setFormations(res.data);
        }
      })
      .finally(() => {
        setFormLoading(false);
      });
  };

  useEffect(() => {
    handleFetchFormations();
  }, []);

  return (
    <>
      <Toast />
      <DialogComponent />
      <FormationForm
        open={formDialogOpen}
        onFormClose={handleCloseformationForn}
        idFormation={selectedFormation.id_formation}
      />
      <Paper>
        <LinearProgress
          sx={{
            borderRadius: "3px 3px 0 0",
            display: formLoading ? "" : "none",
          }}
        />
        <Grid item xs={12} width={"100%"}>
          <CardHeader
            sx={{ m: 2 }}
            title="Formations"
            titleTypographyProps={{ fontWeight: "bold" }}
            action={
              <Grid>
                <AppButton
                  icon={<AddCircleOutlineOutlinedIcon />}
                  text={"Ajouter"}
                  variant={"outlined"}
                  onClick={handleOpenformationFormDialog}
                />
              </Grid>
            }
          />
          {formations.length > 0 ? (
            formations.map((item, index) => (
              <Grid key={index}>
                <ul key={index}>
                  <CardHeader
                    titleTypographyProps={{
                      color: "primary",
                      sx: {
                        fontSize: "20px",
                        fontWeight: "bold",
                        mb: 1,
                      },
                    }}
                    title={`${item.domaine_formation}`}
                    subheader={
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={6} lg={4}>
                          <Stack
                            direction="row"
                            alignItems="center"
                            spacing={1}
                          >
                            <CalendarMonthOutlined />
                            <span>
                              <b>Periode :</b>
                              <br />
                              {` ${new Date(item.date_debut).toLocaleDateString()} au ${new Date(item.date_fin).toLocaleDateString()}`}
                            </span>
                          </Stack>
                        </Grid>
                        <Grid item xs={12} md={6} lg={4}>
                          <Stack
                            direction="row"
                            alignItems="center"
                            spacing={1}
                          >
                            <TopicOutlinedIcon />
                            <span>
                              <b>Theme de la formation :</b> <br />
                              {` ${item.theme_formation || ""}`}
                            </span>
                          </Stack>
                        </Grid>
                        <Grid item xs={12} md={6} lg={4}>
                          <Stack
                            direction="row"
                            alignItems="center"
                            spacing={1}
                          >
                            <WorkspacePremiumOutlinedIcon />
                            <span>
                              <b>FID :</b> <br />
                              {` ${item.fid || ""}`}
                            </span>
                          </Stack>
                        </Grid>
                        <Grid item xs={12} md={6} lg={4}>
                          <Stack
                            direction="row"
                            alignItems="center"
                            spacing={1}
                          >
                            <WorkspacePremiumOutlinedIcon />
                            <span>
                              <b>Autre :</b> <br />
                              {` ${item.autres || ""}`}
                            </span>
                          </Stack>
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          md={6}
                          lg={4}
                          display={
                            String(item.certificat_link).trim() !== ""
                              ? ""
                              : "none"
                          }
                        >
                          <Stack
                            direction="row"
                            alignItems="center"
                            spacing={1}
                          >
                            <WorkspacePremiumOutlinedIcon />
                            <span>
                              <b>Attestation :</b> <br />
                              <a
                                href={item.certificat_link}
                                target="_blank"
                                rel="noreferrer"
                              >
                                {` ${item.certificat || ""}`}
                              </a>
                            </span>
                          </Stack>
                        </Grid>
                      </Grid>
                    }
                  />
                  <CardActions sx={{ justifyContent: "flex-end", mr: 2 }}>
                    <AppButton
                      icon={<EditOutlined />}
                      onClick={(e) => handleEditFormation(item)}
                      text={"Modifier"}
                      variant={"outlined"}
                    />
                    <AppButton
                      icon={<DeleteOutline />}
                      text={"Supprimer"}
                      onClick={(e) => handleDeleteFormation(item)}
                      color={"warning"}
                      variant={"outlined"}
                    />
                  </CardActions>
                </ul>
                <Divider variant="middle" />
              </Grid>
            ))
          ) : (
            <Grid item p={3}>
              <Alert variant="outlined" color="info" icon={<InfoOutlined />}>
                Aucune information
              </Alert>
            </Grid>
          )}
        </Grid>
      </Paper>
    </>
  );
};

export default Formations;
